import script from "./Ai_platform.vue?vue&type=script&setup=true&name=Ai_platform&lang=js"
export * from "./Ai_platform.vue?vue&type=script&setup=true&name=Ai_platform&lang=js"

import "./Ai_platform.vue?vue&type=style&index=0&id=c17e5102&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c17e5102"]])

export default __exports__